import { atom } from 'jotai';

export const deviceKindAtom = atom<string | undefined>(undefined);
deviceKindAtom.debugLabel = 'BulkEditParamsState.deviceKindAtom';

export const deviceIdsAtom = atom<string[] | undefined>(undefined);
deviceIdsAtom.debugLabel = 'BulkEditParamsState.deviceIdsAtom';

/**
 * Header title to show instead of the one on the bulk edit view config.
 *
 * The BFF titles the view from the device kind alone (`Pluralize(deviceKind)` in
 * `upconvert-generate-bulk-edit-view.go`), because `GetEquipmentBulkEditView` is keyed
 * by agent, kind and device ids — it has no notion of which section the user opened the
 * drawer from. When the selection was scoped to one section, the section name is the
 * only thing that matches what the user picked, so the caller supplies it here (UX-4239).
 */
export const titleOverrideAtom = atom<string | undefined>(undefined);
titleOverrideAtom.debugLabel = 'BulkEditParamsState.titleOverrideAtom';

export type PushOutMode = 'edit' | 'preview';

export const pushOutModeAtom = atom<PushOutMode | null>(null);
pushOutModeAtom.debugLabel = 'BulkEditParamsState.pushOutModeAtom';

/** Derived read-only atom — true when any push out mode is active. */
export const pushOutOpenAtom = atom((get) => get(pushOutModeAtom) !== null);
pushOutOpenAtom.debugLabel = 'BulkEditParamsState.pushOutOpenAtom';
